import { useNavigate } from 'react-router';
import MeritoButton from '../../../../components/common/MeritoButtons/MeritoButtons';
import styles from './FinanceBanner.module.scss';
import { FaCoins as CoinIcon } from 'react-icons/fa';
import { HiChevronRight as RightChevron } from 'react-icons/hi'
import { PcSectionRoutes } from '../../pcSections/PcSections';

type Props = {
    showBanner: boolean;
}

const FinanceBanner = ({ showBanner }: Props) => {
    const navigate = useNavigate();

    return (
        <div className={styles.headerRootContainer}>
            <div className={styles.headerTitle}>
                P&L Tracker
            </div>
            {showBanner ? <div className={styles.missingBannerContainer}>
                <div className={styles.iconContainer}>
                    <CoinIcon />
                </div>
                <div className={styles.bannerText}>
                    Track Monthly EBITDA and Net Cash.
                </div>
                <div className={styles.btnContainer}>
                    <MeritoButton btnText="Try Now" type='primary-1' size='sm' icon={<RightChevron />} isIconToRight={true} onClick={() => {
                        navigate(PcSectionRoutes.otherExpenses)
                    }} />
                </div>
            </div> : null}
        </div>
    );
}

export default FinanceBanner;